<app-funnel-shell>
  <div class="guardian">
    <h1 class="guardian__title">{{ 'companion.guardian_page.title' | translate }}</h1>
    @if (loading()) {
      <p class="guardian__muted">…</p>
    } @else if (info(); as i) {
      @switch (i.status) {
        @case ('pending') {
          <p>{{ 'companion.guardian_page.intro' | translate:{ guardian: i.guardian_name, member: i.member_first_name } }}</p>
          <ul class="guardian__list">
            <li>{{ 'companion.guardian_page.points.what' | translate }}</li>
            <li>{{ 'companion.guardian_page.points.data' | translate }}</li>
            <li>{{ 'companion.guardian_page.points.minor' | translate }}</li>
            <li>{{ 'companion.guardian_page.points.revoke' | translate }}</li>
            <li>{{ 'companion.guardian_page.points.no_doctor' | translate }}</li>
          </ul>
          <p class="guardian__muted">{{ 'companion.guardian_page.version' | translate:{ version: i.consent_version } }}</p>
          <div class="guardian__actions">
            <button cButton color="primary" [disabled]="busy()" (click)="act('confirm')">{{ 'companion.guardian_page.confirm' | translate }}</button>
            <button cButton color="secondary" variant="outline" [disabled]="busy()" (click)="act('decline')">{{ 'companion.guardian_page.decline' | translate }}</button>
          </div>
        }
        @case ('confirmed') {
          <p>{{ 'companion.guardian_page.confirmed' | translate:{ member: i.member_first_name, at: (i.confirmed_at | date:'medium') } }}</p>
          <button cButton color="secondary" variant="outline" [disabled]="busy()" (click)="act('revoke')">{{ 'companion.guardian_page.revoke' | translate }}</button>
        }
        @case ('declined') { <p>{{ 'companion.guardian_page.declined' | translate }}</p> }
        @case ('revoked')  { <p>{{ 'companion.guardian_page.revoked' | translate }}</p> }
        @case ('expired')  { <p>{{ 'companion.guardian_page.expired' | translate }}</p> }
        @default           { <p>{{ 'companion.guardian_page.invalid' | translate }}</p> }
      }
      @if (result() === 'error') {
        <p class="text-danger mt-2">{{ 'companion.errors.error' | translate }}</p>
      }
    }
  </div>
</app-funnel-shell>
